import { gql } from "@apollo/client";

export const typeDefs = gql`
  type BookCoursePayload {
    appointments: [Appointment!]!
    clientMutationId: String
  }

  input BookCourseInput {
    courseId: ID!
    clientMutationId: String
  }

  input GetSearchResultInput {
    levelId: Int!
    classType: String!
    days: [String!]!
    time: [Int!]!
    includeStudiedTopics: Boolean!
    categories: [String!]!
    spokenOnly: Boolean!
    numberOfTopicsAhead: Int!
    characters: String!
    cities: [String!]!
  }

  type ClassSchedule {
    date: String!
    lessons: [Lesson!]!
  }

  extend type Query {
    message: String!
    classSearchResult(filter: GetSearchResultInput!): [ClassSchedule!]!
    courses(levelId: ID!, courseType: String!): [Course!]!
    courseDetails(courseId: ID!): Course!
    notifications: [Notification!]!
  }

  extend type Student {
    spokenOnly: Boolean!
  }

  extend type Notification {
    id: ID!
    title: String!
    content: String!
    actionText: String!
    actionUrl: String!
    readAt: String
    createdAt: String!
  }
`;

export const mockStudents = [
  "Aaron",
  "Dimitri",
  "Bruce",
  "Claire",
  "Emmanuel",
  "Fiona",
];

const generateNotification = () => ({
  id: Math.floor(Math.random() * 10),
  title: "Friendly Reminder to Rate Your Class",
  content:
    "You have completed a class. Don’t forget to review learning materials and teacher. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas euismod elit in massa laoreet interdum. Click here to rate class",
  actionText: "Click here to rate class",
  actionUrl: "#",
  readAt: ["2020-07-23 06:15:12", null][Math.floor(Math.random() * 2)],
  createdAt: "2020-07-23 06:15:12",
});

export const resolvers = {
  Student: {
    spokenOnly: () => false,
  },
  Query: {
    notifications: () => [
      generateNotification(),
      generateNotification(),
      generateNotification(),
    ],
  },
};
